/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Clients_Table_Fleet_MoreInputs */

const en_clients_table_fleet_more = /** @type {(inputs: Clients_Table_Fleet_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

const pt_br2_clients_table_fleet_more = /** @type {(inputs: Clients_Table_Fleet_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

/**
* | output |
* | --- |
* | "+{count}" |
*
* @param {Clients_Table_Fleet_MoreInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_table_fleet_more = /** @type {((inputs: Clients_Table_Fleet_MoreInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Table_Fleet_MoreInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_table_fleet_more(inputs)
	return pt_br2_clients_table_fleet_more(inputs)
});